import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-label',
  template: `
    <label [attr.for]="id" class="form-control-label control-label" >
     {{ to?.label || "" }}
      <ng-container> {{ (to.required && to.hideRequiredMarker !== true) ? '*' : ''}} </ng-container>
    </label>
    <ng-template #fieldComponent></ng-template>
  `,
})
export class FormlyLabelWrapper extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef }) fieldComponent: ViewContainerRef;
}
